module.exports = __webpack_public_path__ + "static/media/thumb.a5c2701e.jpg";